import React from 'react';

import ActionButton from 'jbc-front/components/ActionButton';
import Contract from 'jbc-front/components/icons/Contract';
import { useTranslation } from 'react-i18next';

const CollapseActionBtn = props => {
  const { t } = useTranslation();
  const { onClick, label = t('buttons.CollapseActionBtn.CollapseActionBtn.Close_all'), ...rest } = props;
  return (
    <ActionButton as="button" icon={<Contract />} onClick={onClick} {...rest}>
      {label}
    </ActionButton>
  );
};

export default CollapseActionBtn;
